export default "__VITE_ASSET__BUCyOyxx__"